/**
 * Google reCAPTCHA, loaded only when a page asks for it (27 Oct 2026, Outreach v1 checkpoint 11
 * fix round 3). It used to be installed for the whole app by a plugin, so every page load, the
 * anonymous feedback page included, fetched Google's script and Google saw the visit. Now the
 * three pages that send a reCAPTCHA answer (sign up, forgot password, contact) start it when they
 * open, so it still watches the page before the answer is asked for, and it never loads on a
 * session free page. Pure: `loadLibrary` is how the library itself is fetched.
 */
import {sessionFreeRoute} from './sessionFreeRoutes.js';

/** The same options the old plugin gave: badge hidden, served from recaptcha.net. */
export const RECAPTCHA_LOADER_OPTIONS = Object.freeze({
    autoHideBadge: true,
    useRecaptchaNet: true,
    renderParameters: {hl: 'id'},
});

export function createRecaptchaLoader(loadLibrary) {
    let ready = null;
    return {
        /** The reCAPTCHA instance (with execute(action)), or null when nothing may be loaded. */
        load(siteKey, path) {
            if (!siteKey || sessionFreeRoute(path)) return Promise.resolve(null);
            if (!ready) {
                ready = Promise.resolve()
                    .then(() => loadLibrary())
                    .then((library) => (library.load ?? library.default?.load)(siteKey, RECAPTCHA_LOADER_OPTIONS))
                    .catch((e) => {
                        ready = null;
                        throw e;
                    });
            }
            return ready;
        },
    };
}
